<template>
  <div id="content" class="content">
    <div class="content__button-block"></div>
    <div class="content__text-block">
      <h1 class="h1">Resultat</h1>
      <p>Här hittar du resultat från tidigare års tävling.</p>
      <ul class="content__year-list">
        <li>
          <a href="https://my.raceresult.com/408258/" target="iframe">2026</a>
        </li>
        <li>
          <a href="https://my.raceresult.com/346881/" target="iframe">2025</a>
        </li>
        <li>
          <a href="https://my.raceresult.com/297168/results" target="iframe"
            >2024</a
          >
        </li>
        <li>
          <a
            href="https://results.neptron.se/#/satertriathlon2023/"
            target="iframe"
            >2023</a
          >
        </li>
        <li>
          <a
            href="https://www.mittlopp.se/Resultat/CZNNXUYJNJBXWZKXNG"
            target="iframe"
            >2022</a
          >
        </li>
        <!-- <li><a href="../assets/documents/resultat-2021.pdf" target="iframe">2021</a></li> -->
      </ul>
      <iframe
        src="https://my.raceresult.com/297168/results"
        name="iframe"
        class="content__iframe"
        frameborder="0"
      ></iframe>
      <!-- <pdf src="resultat-2021.pdf"></pdf> -->
    </div>
  </div>
</template>

<script>
export default {
  Name: "Registration",
  components: {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
.content {
  flex-direction: column;

  &__text-block {
    width: 100%;
  }

  &__button-block {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  &__year-list {
    list-style: none;
    padding: 10px;
    border-bottom: 1px solid black;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 32px;

    a {
      text-decoration: none;
      color: black;
      font-weight: bolder;

      &:hover {
        color: rgb(66, 66, 66);
      }
    }
  }

  &__iframe {
    width: 100%;
    height: 500px;
  }

  @media only screen and (max-width: 750px) {
    flex-direction: column;
  }
}

.h1 {
  font-size: 50px;
}
</style>
